module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 17
// module chunks = 0